//import { any, func, string } from 'prop-types';

import React, { useState, useEffect, useContext } from 'react';
import format from 'date-fns/format';
import sub from 'date-fns/sub';
import isAfter from 'date-fns/isAfter';
import styled from 'styled-components';
import LoadingCube from 'sub_components/Common/LoadingCube';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { FilterContext } from 'context/FilterContext';
import { SortContext } from 'context/SortContext';
import { ComponentFooter } from 'styled_components/Common/ComponentFooter';
import { Divider } from 'styled_components/Common/Divider';
import { RESOLUTIONS } from 'services/config';
import { Utils } from 'services/utils';

// const handleColorType = (module, theme) => {
// 	switch (module.toLowerCase()) {
// 		case 'storage':
// 			return theme.storage;
// 		case 'account':
// 			return theme.account;
// 		case 'billing':
// 			return theme.billing;
// 		case 'support':
// 			return theme.support;
// 		default:
// 			return theme.main;
// 	}
// };
function getSize(breakpoint) {
	let size = 'medium';
	if (breakpoint === RESOLUTIONS.MED) {
		size = 'medium';
	} else if (breakpoint === RESOLUTIONS.HIGH) {
		size = 'medium';
	}

	return size;
}

const NotificationsStyle = styled.div`
	position: relative;
	background: ${props => props.theme.componentBackground};
	height: 264px;
	#filter {
		right: 168px;
		top: -40px;
	}
	#sort {
		right: 0;
		top: -40px;
	}
	.notifications-header {
		height: 40px;
		.header-titles {
			width: 100%;
			padding-top: 15px;
			padding-left: 64px;
			padding-right: 64px;
			display: flex;
			justify-content: space-between;
			.header-title {
				color: ${props => props.theme.Cool_Gray_Dark_2};
				display: flex;
				align-items: end;
				width: 48px;
				height: 18px;
				&.md {
					width: 80px;
				}
				&.lg {
					width: 176px;
				}
			}
		}
	}
	.notifications-body {
		position: relative;
		height: 164px;
		padding-left: 64px;
		padding-right: 64px;
		.error-message {
			padding-top: 15px;
			text-align: center;
		}
		.body-row {
			display: flex;
			justify-content: space-between;
			height: 16px;
			margin-top: 10px;
			.value {
				width: 48px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding-bottom: 15px;
				padding-left: 2px;
				background-color: ${props => props.theme.Cool_Gray_Med_3};
				color: ${props => props.theme.Cool_Gray_Dark_2};
				&.md {
					width: 80px;
				}
				&.lg {
					width: 176px;
				}
			}
		}
	}
	.ScrollbarsCustom-Track {
		right: -35px !important;
		top: 10px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.account} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 416px;

		#filter {
			right: 184px;
			top: -56px;
		}
		#sort {
			right: 0;
			top: -56px;
		}

		.notifications-header {
			height: 60px;
			.header-titles {
				padding-top: 35px;
				padding-left: 64px;
				padding-right: 64px;
				.header-title {
					width: 64px;
					height: 18px;
					&.md {
						width: 128px;
					}
					&.lg {
						width: 224px;
					}
				}
			}
		}
		.notifications-body {
			height: 250px;
			padding-left: 64px;
			padding-right: 64px;
			.body-row {
				height: 16px;
				margin-top: 15px;
				.value {
					width: 64px;
					&.md {
						width: 128px;
					}
					&.lg {
						width: 224px;
					}
				}
			}
		}

		.ScrollbarsCustom-Track {
			right: -37px !important;
			top: 15px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 8px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 8px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 524px;
		#filter {
			right: 232px;
			top: -64px;
		}
		#sort {
			right: 0;
			top: -64px;
		}

		.notifications-header {
			height: 100px;
			.header-titles {
				padding-top: 70px;
				padding-left: 136px;
				padding-right: 136px;
				.header-title {
					width: 74px;
					height: 16px;
					&.md {
						width: 183px;
					}
					&.lg {
						width: 288px;
					}
				}
			}
		}
		.notifications-body {
			height: 410px;
			padding-left: 136px;
			padding-right: 136px;
			.body-row {
				height: 20px;
				margin-top: 15px;
				.value {
					width: 74px;
					&.md {
						width: 183px;
					}
					&.lg {
						width: 288px;
					}
				}
			}
		}

		.ScrollbarsCustom-Track {
			right: -75px !important;
			top: 15px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 10px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 10px !important;
		}
	}
`;

function sortNotifications(selectedSort, notifications) {
	let newNotifications = notifications;
	const newDate = format(new Date(), 'MM-dd-yy');
	const today = sub(newDate, { days: selectedSort?.value });

	const filterNotifications = [];
	switch (selectedSort?.displayValue) {
		case '30 Days - ASC':
			newNotifications = Utils.sort(notifications).reverse();
			// last 30 days

			notifications.forEach(notification => {
				if (isAfter(format(new Date(notification.displayDate), 'MM-dd-yy'), today)) {
					filterNotifications.push(notification);
				}
			});
			newNotifications = filterNotifications;
			break;
		case '180 Days - ASC':
			newNotifications = Utils.sort(notifications).reverse();
			// last 180 days

			notifications.forEach(notification => {
				if (isAfter(format(new Date(notification.displayDate), 'MM-dd-yy'), today)) {
					filterNotifications.push(notification);
				}
			});
			newNotifications = filterNotifications;
			break;

		case '30 Days - DESC':
			newNotifications = Utils.sort(notifications);

			notifications.forEach(notification => {
				if (isAfter(format(new Date(notification.displayDate), 'MM-dd-yy'), today)) {
					filterNotifications.push(notification);
				}
			});
			newNotifications = filterNotifications;
			break;

		case '180 Days - DESC':
			newNotifications = Utils.sort(notifications);

			notifications.forEach(notification => {
				if (isAfter(format(new Date(notification.displayDate), 'MM-dd-yy'), today)) {
					filterNotifications.push(notification);
				}
			});
			newNotifications = filterNotifications;
			break;

		default:
		// code block
	}

	return newNotifications;
}

export const Notifications = ({
	className,
	id,
	module,
	breakpoint,
	children,
	portalLogs,
	badgeLogs,
}) => {
	const [notifications, setNotifications] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);
	const { filterData } = useContext(FilterContext);
	const { sortData } = useContext(SortContext);
	const selectedFilter = filterData?.selected;
	const selectedSort = sortData?.selected;

	useEffect(() => {
		setError(null);
		setIsLoading(true);
		if (selectedFilter === 'Portal Logins') {
			setNotifications([]);
			const sortedNotifications = sortNotifications(selectedSort, portalLogs);
			setIsLoading(false);
			setTimeout(() => setNotifications(sortedNotifications), 500);
		} else if (selectedFilter === 'Badge Access') {
			if (badgeLogs && badgeLogs.length !== 0) {
				const sortedNotifications = sortNotifications(selectedSort, badgeLogs);
				setTimeout(() => setNotifications(sortedNotifications), 500);
			} else {
				setNotifications([]);
				setError('No Badge Logs to display.');
			}
		} else {
			let allNotifications = [];

			if (portalLogs && badgeLogs) {
				allNotifications = badgeLogs.concat(portalLogs);
				const sortedNotifications = sortNotifications(selectedSort, allNotifications);
				setTimeout(() => setNotifications(sortedNotifications), 500);
			}
			if (!badgeLogs) {
				allNotifications = portalLogs;
				const sortedNotifications = sortNotifications(selectedSort, allNotifications);
				setTimeout(() => setNotifications(sortedNotifications), 500);
			}
			setNotifications(allNotifications);
		}

		setIsLoading(false);
	}, [selectedFilter, selectedSort, portalLogs, badgeLogs]);

	return (
		<NotificationsStyle id={id} className={className} module={module}>
			<div className='notifications-header'>
				<div className='header-titles'>
					<div className='header-title md labels21'>Username</div>
					<div className='header-title lg labels21'>Description</div>
					<div className='header-title sm labels21'>City</div>
					<div className='header-title sm labels21'>Date</div>
					<div className='header-title sm labels21'>Time</div>
				</div>
			</div>
			<div className='notifications-body'>
				<Divider />
				{isLoading && <LoadingCube />}
				{error && <div className='error-message body10'>{error}</div>}
				<ScrollView>
					{notifications &&
						notifications.map((item, key) => (
							<div
								className='body-row'

								index={`${key}-${item.startDate}`}
								//eslint-disable-next-line
								key={`${key}-${item?.startDate}-${item.displayTime}`}
							>
								<div className='value md body10'>{item.username}</div>
								<div className='value lg body10'>{item.type}</div>
								<div className='value sm body10'>{item.city}</div>
								<div className='value body10'>{item.displayDate}</div>
								<div className='value body10'>{item.displayTime}</div>
							</div>
						))}
				</ScrollView>
			</div>
			<ComponentFooter
				cypressId='notifications-footer'
				id='notifications-footer'
				buttonText1={'ONE'}
				buttonText2='Back'
				buttonActive1={true}
				buttonActive2={true}
				module='account'
				//buttonFunction1={() => {}}
				size={getSize(breakpoint)}
				//buttonFunction2={() => {}}
			/>
			{children}
		</NotificationsStyle>
	);
};
Notifications.propTypes = {};

Notifications.defaultProps = {};
